var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var ExportModelStateMachine = require("./exportModelStateMachine.js");
var ExportModelModel = require("./exportModelModel.js");
var ExportModelView = require("./exportModelView.js");
var PackageMasterController = require("../packageMasterView/packageMasterController.js");

var ExportModelController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        EXPORT_MODEL_PRESSED:                {id: 'export_model_01', name: "UI_EXPORT_MODEL_PRESSED" },
        EXPORT_MODEL_OBJ:                    {id: 'export_model_02', name: "EXPORT_MODEL_OBJ" },
        EXPORT_MODEL_STEP:                   {id: 'export_model_03', name: "EXPORT_MODEL_STEP" },
        EXPORT_MODEL_CANCEL:                 {id: 'export_model_05', name: "EXPORT_MODEL_CANCEL" },
        EXPORT_MODEL_LBR:                    {id: 'export_model_06', name: "EXPORT_MODEL_LBR" },
        EXPORT_LBR_MAKEVERSION:              {id: 'export_model_07', name: "EXPORT_LBR_MAKEVERSION" },
        MAKEVERSION_MODAL_CANCEL:            {id: 'export_model_08', name: "MAKEVERSION_MODAL_CANCEL" },
        EXPORT_MODEL_F3D:                    {id: 'export_model_09', name: "EXPORT_MODEL_F3D" },
    });
};

lib_core.inherit(ExportModelController, lib_core.Controller);

if(typeof window !== 'undefined'){
    var ui_extensions = require("ui-extensions");

    ExportModelController.inject = {
         tabController            : ui_extensions.TabController,
         processMessageController : ui_extensions.ProcessMessageController,
         errorController          : ui_extensions.ErrorMessageController,
         sidebarController        : ui_extensions.SidebarController,
         masterController         : PackageMasterController
    };
}

module.exports = ExportModelController;

ExportModelController.prototype.beforeLoad = function() {
    var self = this;

    if(this.configuration && this.configuration.button) {
        this.toggleButton = this.tabController.getView().registerButton({
            name: this.configuration.button.name,
            title: this.configuration.button.title,
            sortOrder: this.configuration.button.sortOrder,
            eventType: lib_core.GuiEvents.EXPORT_MODEL_PRESSED,
            style: {
                icon: this.configuration.button.style.icon,
            },
            group: "toggle buttons",
            position: "right"
        });
    }

    lib_core.Controller.prototype.beforeLoad.call(this);
};


ExportModelController.prototype.createStateMachine = function () {
    // TODO solve this
    var versionController = this.sidebarController && this.sidebarController.children.get('versions');
    var versionSM = versionController && versionController.getStatemachine();

    return new ExportModelStateMachine(this.root, this.getModel(), this.processMessageController.getModel(), versionSM );
};

ExportModelController.prototype.createModel = function () {
    return new ExportModelModel();
};

ExportModelController.prototype.createView = function () {
    return new ExportModelView(this.getModel(), this.getStatemachine(), this.root, this.masterController.getModel(), this.toggleButton);
};



